(() => {
  const name = 'emptyModule';

  App[name] = (() => {
    const init = function () {

    };

    return {
      init,
    };
  })();
})();
